<div class="attachments-panel flex-col gap-16 p-16">
  @if (attachmentLoadState() === LoadState.LOADING || attachmentLoadState() === LoadState.ERROR) {
    <div class="flex-col gap-16">
      @for (group of [1, 2]; track group) {
        <div class="skeleton-attachment-group flex-col gap-12">
          <div class="skeleton-attachment-group-header flex-row items-center gap-12">
            <div class="skeleton skeleton-avatar-circle"></div>
            <div class="flex-col gap-6">
              <div class="skeleton skeleton-attachment-origin-name"></div>
              <div class="skeleton skeleton-attachment-origin-desc"></div>
            </div>
          </div>
          <div class="skeleton-attachment-cards-grid">
            @for (card of [1, 2, 3]; track card) {
              <div class="skeleton-attachment-card flex-row items-center gap-16">
                <div class="skeleton skeleton-attachment-icon"></div>
                <div class="flex-col gap-4" style="flex: 1; min-width: 0;">
                  <div class="skeleton skeleton-attachment-name"></div>
                  <div class="skeleton skeleton-attachment-meta"></div>
                </div>
                <div class="skeleton skeleton-attachment-action"></div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else if (isAttachmentsEmpty()) {
    <aionz-empty-content
      title="Não há anexos disponíveis"
      description="Nenhum anexo foi vinculado a esta solicitação."
      icon="attach_file"
    ></aionz-empty-content>
  } @else {
    <div class="attachments-list flex-col gap-16">
      @for (group of attachmentGroups(); track group.name) {
        <aionz-attachment-group
          [group]="group"
          (downloadAttachment)="downloadAttachment($event)" />
      }
    </div>
  }
</div>
